var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefurbishHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.1 508.1",
    style: {
      enableBackground: "new 0 0 508.1 508.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M467.9,152.25H40.1c-11.7,0-21.2,9.5-21.2,21.2v283.1h169.7c0,5.4,4.3,9.7,9.7,9.7h111.3 c5.4,0,9.7-4.4,9.7-9.7h169.8v-283.1C489.1,161.75,479.6,152.25,467.9,152.25z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7,
    y: 186.15,
    style: {
      fill: "#048FEA"
    },
    width: 402.5,
    height: 236.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD6E0"
    },
    d: "M319.4,456.55c0,5.4-4.4,9.7-9.7,9.7H198.4c-5.4,0-9.7-4.4-9.7-9.7H0v20.3 c0,17.3,13.9,31.2,31.1,31.2H477c17.2,0,31.1-13.9,31.1-31.1v-20.3H319.4V456.55z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFD15C"
    },
    cx: 254,
    cy: 304.45,
    rx: 100.5,
    ry: 100.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F8B64C"
    },
    cx: 254,
    cy: 304.45,
    rx: 76.5,
    ry: 76.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M241.5,335.35c-2.2-2.9-3.7-6.3-4.5-10.3l-19.5,2.1c1.5,9.8,4.9,17.4,10.3,22.8 c5.4,5.4,12.4,8.6,21,9.7v9.8h10.8v-10.2c9.7-1.4,17.3-5.2,22.7-11.4c5.5-6.2,8.2-13.8,8.2-22.8c0-8.1-2.2-14.7-6.5-19.9 c-4.3-5.2-12.5-9.4-24.4-12.6v-29.3c4.8,2.1,7.8,6.1,9,12l18.9-2.5c-1.3-7.5-4.3-13.5-9-17.9c-4.7-4.5-11-7.2-18.9-8.1v-7.4h-10.8 v7.4c-8.6,0.8-15.4,4.1-20.6,9.6c-5.2,5.6-7.7,12.4-7.7,20.6c0,8.1,2.3,15,6.8,20.6c4.6,5.7,11.7,9.9,21.5,12.7v31.3 C246.1,340.35,243.6,338.25,241.5,335.35z M259.6,313.55c4.5,1.3,7.7,3.2,9.7,5.6c2,2.4,3,5.3,3,8.6c0,3.7-1.2,7-3.5,9.8 s-5.4,4.5-9.1,5.2v-29.2H259.6z M241.5,283.55c-1.6-2.3-2.4-4.7-2.4-7.4c0-2.9,0.9-5.5,2.6-7.9c1.7-2.4,4.1-4.1,7-5.1v25.9 C245.5,287.65,243.1,285.75,241.5,283.55z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFD15C"
    },
    cx: 364.4,
    cy: 156.55,
    rx: 57.7,
    ry: 57.8
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F8B64C"
    },
    cx: 364.4,
    cy: 156.55,
    rx: 43.9,
    ry: 44
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M357.2,174.35c-1.3-1.7-2.1-3.6-2.6-5.9l-11.2,1.2c0.9,5.6,2.8,10,5.9,13.1s7.1,4.9,12.1,5.5v5.6 h6.2v-5.8c5.6-0.8,9.9-3,13.1-6.5c3.1-3.6,4.7-7.9,4.7-13.1c0-4.6-1.2-8.4-3.7-11.4s-7.2-5.4-14-7.2v-16.8c2.8,1.2,4.5,3.5,5.1,6.9 l10.9-1.4c-0.7-4.3-2.5-7.7-5.1-10.3c-2.7-2.6-6.3-4.1-10.9-4.7v-4.3h-6.2v4.3c-4.9,0.5-8.9,2.3-11.8,5.5c-3,3.2-4.4,7.1-4.4,11.8 c0,4.6,1.3,8.6,3.9,11.8c2.6,3.3,6.7,5.7,12.3,7.3v18C359.8,177.15,358.4,175.95,357.2,174.35z M367.6,161.75 c2.6,0.7,4.4,1.8,5.6,3.2c1.1,1.4,1.7,3,1.7,5c0,2.1-0.7,4-2,5.6s-3.1,2.6-5.2,3v-16.8H367.6z M357.2,144.55 c-0.9-1.3-1.4-2.7-1.4-4.2c0-1.7,0.5-3.2,1.5-4.6c1-1.4,2.3-2.3,4-2.9v14.9C359.5,146.85,358.1,145.85,357.2,144.55z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFD15C"
    },
    cx: 174.8,
    cy: 57.85,
    rx: 57.7,
    ry: 57.8
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F8B64C"
    },
    cx: 174.8,
    cy: 57.85,
    rx: 43.9,
    ry: 44
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M167.6,75.65c-1.3-1.7-2.1-3.6-2.6-5.9l-11.2,1.2c0.9,5.6,2.8,10,5.9,13.1c3.1,3.1,7.1,4.9,12.1,5.5 v5.6h6.2v-5.8c5.6-0.8,9.9-3,13.1-6.5c3.1-3.6,4.7-7.9,4.7-13.1c0-4.6-1.2-8.4-3.7-11.4s-7.2-5.4-14-7.2v-16.9 c2.8,1.2,4.5,3.5,5.1,6.9l10.9-1.4c-0.7-4.3-2.5-7.7-5.1-10.3c-2.7-2.6-6.3-4.1-10.9-4.7v-4.3h-6.2v4.3c-4.9,0.5-8.9,2.3-11.8,5.5 c-3,3.2-4.4,7.1-4.4,11.8c0,4.6,1.3,8.6,3.9,11.8c2.6,3.3,6.7,5.7,12.3,7.3v18C170.3,78.55,168.9,77.35,167.6,75.65z M178.1,63.15 c2.6,0.7,4.4,1.8,5.6,3.2c1.1,1.4,1.7,3,1.7,5c0,2.1-0.7,4-2,5.6s-3.1,2.6-5.2,3v-16.8H178.1z M167.7,45.85 c-0.9-1.3-1.4-2.7-1.4-4.2c0-1.7,0.5-3.2,1.5-4.6c1-1.4,2.3-2.3,4-2.9v14.9C170,48.25,168.6,47.15,167.7,45.85z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ACB3BA"
    },
    points: "415.4,340.55 377.2,327.05 373.5,367.55 385.7,359.65 399.9,381.75 417.4,370.55  403.2,348.35 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefurbishHover);
export default __webpack_public_path__ + "static/media/RefurbishHover.942229574ee68ae7834049925edb13df.svg";
export { ForwardRef as ReactComponent };